import type { DocumentV3 } from '@docgen/schema';
import type { EditorLibraryActions } from './page-library';

/**
 * The proposal editor open in this tab, if any, so BESTie's page library cards
 * act through it: an Add or Save then saves the person's pending edits first,
 * inserts after the selected page, and shows the result straight away. When
 * no editor is open on that proposal, the cards call the API themselves.
 * In-page only, like `live.ts`.
 */
export interface OpenProposalEditor {
  readonly proposalId: string;
  /** The document as the editor holds it now (for thumbnails with this deal's data). */
  readonly currentDoc: () => DocumentV3 | null;
  readonly library: EditorLibraryActions;
}

let openEditor: OpenProposalEditor | null = null;

/** The editor registers itself while it shows a proposal; returns the unregister. */
export function registerOpenEditor(editor: OpenProposalEditor): () => void {
  openEditor = editor;
  return () => {
    if (openEditor === editor) openEditor = null;
  };
}

/** The open editor when it is showing this proposal. */
export function openEditorFor(proposalId: string): OpenProposalEditor | undefined {
  return openEditor?.proposalId === proposalId ? openEditor : undefined;
}
